<template>
  <component
    v-if="!!readonly && model"
    :is="computedIs"
    :id="model.id"
    ref="refHeading"
    class="whitespace-normal pb-2"
    >
    {{ !!computedContent ? computedContent : model.content }}
  </component>
  <blog-content-edit-wrapper v-else-if="model" v-model="model">
    <div>
      <ui-text
        :id="'content_'+model.id"
        v-model="computedContent"
        label="Content"
        />
    </div>

    <ui-select
      v-if="model?.meta"
      v-model="model.meta.headline_type"
      label="Headline Type"
      >
      <ui-select-option value="h1"/>
      <ui-select-option value="h2"/>
      <ui-select-option value="h3"/>
      <ui-select-option value="h4"/>
      <ui-select-option value="h5"/>
      <ui-select-option value="h6"/>
    </ui-select>
  </blog-content-edit-wrapper>
</template>

<script setup lang="ts">
defineEmits(['remove'])
defineProps<{ readonly?: boolean }>()

const model = defineModel<BlogElement>()
const refHeading = ref();
const route = useRoute()
const { locale } = useI18n()

onMounted(() => {
  if (!model.value) model.value = {} as BlogElement
  if (!model.value.meta) model.value.meta = {} as BlogElementMeta
  if (!model.value.meta.headline_type) model.value.meta.headline_type = 'h2'

  setTimeout(() => {
    if(route.hash && route.hash === '#'+model.value?.id) {
      console.log('scrolling to', model.value?.id)
      refHeading.value?.scrollIntoView({ behavior: 'smooth' })
    }
  },100)
})

const computedIs = computed(() => {
  return model.value?.meta?.headline_type ?? 'h2';
})

const computedContent = computed({
  get: () => {
    if(!model.value) return ''

    return ((model.value.editing_language ?? locale.value) != 'en')
      ? (model.value.meta.i18n?.[model.value.editing_language ?? locale.value]?.content
        ? model.value.meta.i18n?.[model.value.editing_language ?? locale.value]?.content
        : model.value.content
      )
      : model.value.content
  },
  set: (value) => {
    if(!model.value) return

    if ((model.value.editing_language ?? locale.value) != 'en') {
      model.value.meta.i18n[model.value.editing_language ?? locale.value].content = value
    } else {
      model.value.content = value
    }
  },
})
</script>
